import { useEffect, useRef, useState } from "react";
import "../styles/AboutUsPage.css";
import Header from "../components/HeaderThree";

import AboutUs from '../components/About';
import { motion } from "framer-motion";

import image1 from "../assets/images/OurVision.avif";
import image2 from "../assets/images/ourmission.avif";
import AboutBg from "../assets/images/about-us-img.svg";
import { executiveData } from "../data/leadershipData";

import TrustIcon from "../assets/icons/trusted-seller.png";
import EmpathyIcon from "../assets/icons/customer-engagement.png";
import CreativityIcon from "../assets/icons/creativity.png";

import leftimage from '../assets/images/about_us_left_image.webp';
import whiteLogo from '../assets/images/logo/logo-white.png';
import backgroundimage from '../assets/images/about_us_background.jpg';


export default function RelentlessHero() {
    const bgRef = useRef(null);
    const sectionRef = useRef(null);

    const [activeTab, setActiveTab] = useState("executive");
    const [leaders, setLeaders] = useState(executiveData);
    const [index, setIndex] = useState(0);

    const excellenceHeading =
        "Building Excellence, Creating Timeless Living".split(" ");

    const leadershipHeading =
        "Leadership with vision of future".split(" ");


    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current || !bgRef.current) return;

            const rect = sectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate progress based on scroll
            const progress = Math.min(
                Math.max((windowHeight - rect.top) / (windowHeight + rect.height), 0),
                1
            );

            // Apply scale transformation to background image
            const scale = 1 + progress * 0.3; // 1 → 1.3
            bgRef.current.style.transform = `scale(${scale})`;

            // Prevent horizontal scrolling by containing the image
            bgRef.current.style.width = "100%";
            bgRef.current.style.maxWidth = "100vw";
            bgRef.current.style.overflow = "hidden";
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const [selectedLeader, setSelectedLeader] = useState(null);

    /* reset line when tab changes */
    const switchTab = (tab) => {
        setActiveTab(tab);
        setLeaders(tab === "executive");
        setIndex(0);
    };

    const visibleSlides = 4;
    const maxIndex = leaders.length - visibleSlides;
    const progress = maxIndex <= 0 ? 0 : (index / maxIndex) * 100;

    const nextSlide = () => {
        if (index < maxIndex) setIndex(index + 1);
    };

    const prevSlide = () => {
        if (index > 0) setIndex(index - 1);
    };

    // Animation variants
    const containerVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.25,
            },
        },
    };

    const fadeUp = {
        hidden: {
            y: 40,
            opacity: 0,
            filter: "blur(6px)",
        },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: {
                duration: 0.8,
                ease: "easeOut",
            },
        },
    };

    const slideLeft = {
        hidden: { opacity: 0, x: -60, filter: "blur(6px)" },
        show: {
            opacity: 1,
            x: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    const slideRight = {
        hidden: { opacity: 0, x: 60, filter: "blur(6px)" },
        show: {
            opacity: 1,
            x: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    // Word-by-word animation variants for hero text
    const wordContainer = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.2,
            },
        },
    };

    const wordVariant = {
        hidden: {
            y: 40,
            opacity: 0,
            filter: "blur(6px)"
        },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: {
                duration: 0.9,
                ease: "easeOut",
            },
        },
    };

    // Split hero text into words
    const line1 = "We build our projects".split(" ");
    const line2 = "with your dreams and ideas".split(" ");

    return (
        <>
            <Header />

            <section
                className="about-hero container-fluid py-5"
                id="about-section"
                ref={sectionRef}
                style={{ overflowX: "hidden" }}
            >
                <div className="container h-100 py-5 px-lg-0">
                    <motion.div
                        className="about-content py-5 row h-100"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.4 }}
                    >
                        <div className="col-lg-7 px-lg-0 d-flex flex-column left-side">
                            <motion.h1
                                className="display-3"
                                variants={wordContainer}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: false, amount: 0.6 }}
                            >
                                {line1.map((word, i) => (
                                    <motion.span
                                        key={`line1-${i}`}
                                        variants={wordVariant}
                                        style={{ display: 'inline-block', marginRight: '0.35em' }}
                                    >
                                        {word}
                                    </motion.span>
                                ))}
                                <br />
                                {line2.map((word, i) => (
                                    <motion.span
                                        key={`line2-${i}`}
                                        variants={wordVariant}
                                        style={{ display: 'inline-block', marginRight: '0.35em', color: "#6b6b6b" }}
                                    >
                                        {word}
                                    </motion.span>
                                ))}
                            </motion.h1>
                        </div>

                        <div className="col-lg-5 px-lg-0 d-flex justify-content-end flex-column right-side">
                            <motion.p
                                className="about-subtext pertili-font"
                                variants={fadeUp}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: false, amount: 0.4 }}
                            >
                                The Vessella Group stands a level above with a strong foundation and wealth of experience in building homes. <span>We like to think of ourselves as 'fine home connoisseurs' delivering innovative, premium experiences to residents looking for a touch of class and calm in their living spaces.
                                </span>
                            </motion.p>
                        </div>
                    </motion.div>
                </div>

                <button
                    className="explore-btn"
                    onClick={() =>
                        document
                            .getElementById("intro-section")
                            .scrollIntoView({ behavior: "smooth" })
                    }
                >
                    <span className="explore-arrows">
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                        <svg viewBox="0 0 4 8">
                            <path d="M2.86 0.89L1.15 3.89L2.86 6.9" />
                        </svg>
                    </span>

                    <span className="explore-text geist-font">EXPLORE</span>
                </button>
                <div className="hero-blue-overlay" />
            </section>
            <AboutUs />


            {/* Fixed width container for the background image 
           <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
                <div style={{ 
                    width: "100%", 
                    maxWidth: "100vw", 
                    overflow: "hidden",
                    position: "relative"
                }}>
                    <img
                        src={AboutBg}
                        alt="Background"
                        className="img-fluid"
                        ref={bgRef}
                        style={{ 
                            width: "100%",
                            maxWidth: "100%",
                            height: "auto",
                            display: "block"
                        }}
                    />
                </div>
            </div>
*/}


            <section className="py-5 container-fluid d-flex arrow-section"
                id="intro-section"
            >

                {/* Background Image */}
                {/* <img
                    src={backgroundimage}
                    alt="background"
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{ objectFit: "cover", zIndex: 0 }}
                /> */}


                <div className="row w-100 flex-lg-wrap flex-wrap-reverse">

                    {/* Left Image Animation */}
                    {/* <div
                            className="col-lg-6 mb-4 mb-lg-0 p-0"

                        >
                            <img
                                src={leftimage}
                                alt="Growth chart"
                                className="img-fluid"
                            />
                        </div> */}

                    {/* Right Content Animation */}
                    <motion.div
                        className="col-lg-7 d-flex flex-column justify-content-center text-white px-5"
                        initial={{ opacity: 0, y: 80 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                        viewport={{ once: false }}
                    >
                        <img
                            src={whiteLogo}
                            alt="Growth chart"
                            className="white-logo mb-lg-5 mb-3"
                        />

                        <h2
                            className="mb-4 pertili-font"

                        >
                            Every Vessella project reflects our commitment to quality, transparency, and timeless design, creating serene, secure, and sophisticated spaces where families grow and futures are secured.
                        </h2>


                    </motion.div>


                    {/* <motion.div
                        className="col-lg-4 d-flex align-items-center justify-content- px-4"
                        initial={{ opacity: 0, y: -80 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                        viewport={{ once: false }}
                    >

                        <img
                            src={whiteLogo}
                            alt="Growth chart"
                            className="white-logo"
                        />

                    </motion.div> */}

                </div>

            </section>

            <motion.section
                className="about-section-three py-5"
                variants={containerVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.2 }}
                style={{ overflowX: "hidden" }}
            >
                {/* <div className="container">
                   
                    <motion.div className="about-label mb-4" variants={fadeUp}>
                        <span className="about-dot"></span>
                        <span className="about-label-text">Our Capabilities</span>
                    </motion.div>

                    <motion.h2 className="about-heading mb-5" variants={fadeUp}>
                        Unique solutions for your home through a personalized process.
                    </motion.h2>

                    <div className="row g-4">
                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={TrustIcon} className="mb-3" style={{ width: "50px" }} alt="Trust Icon" />
                                <p>We adhere to high standards of honesty and strong business ethics. We do right by all our customers and stakeholders every time with no exceptions</p>
                            </div>
                        </motion.div>

                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={EmpathyIcon} className="mb-3" style={{ width: "50px" }} alt="Empathy Icon" />
                                <p>We strive to motivate, influence, energize and stimulate our employees through the most conducive work environment.</p>
                            </div>
                        </motion.div>

                        <motion.div className="col-md-4" variants={fadeUp}>
                            <div className="about-card">
                                <img src={CreativityIcon} className="mb-3" style={{ width: "50px" }} alt="Creativity Icon" />
                                <p>We encourage progressive and forward-thinkers who engage in fresh ideas for better solutions and superior outcomes.</p>
                            </div>
                        </motion.div>
                    </div>
                </div> */}

                <div className="container py-4 mt-5">
                    <motion.div
                        className="about-label mb-4"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false }}
                    >
                        {/* <span className="about-dot"></span>
                        <span className="about-label-text">
                            Pioneers in leadership and growth
                        </span> */}
                    </motion.div>

                    <motion.h2
                        className="about-heading"
                        variants={wordContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        {excellenceHeading.map((word, i) => (
                            <motion.span
                                key={`excellence-${i}`}
                                variants={wordVariant}
                                style={{ display: "inline-block", marginRight: "0.35em" }}
                            >
                                {word}
                            </motion.span>
                        ))}
                    </motion.h2>


                    {/* Vision Section */}
                    <motion.div
                        className="row py-5"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <motion.div
                            className="col-md-6 p-lg-3"
                            variants={slideLeft}
                        >
                            <img
                                src={image1}
                                alt="Vision"
                                className="img-fluid"
                                style={{ borderRadius: "10px", borderEndEndRadius: "50px" }}
                            />
                        </motion.div>
                        <motion.div
                            className="col-md-6 py-5"
                            variants={slideRight}
                        >
                            <h2 className="mb-3 display-5">Vision</h2>
                            <p className="text-gray-vessella pertili-font fs-3">
                                To be acknowledged for unsurpassed excellence in construction and to occupy the top slot, both in business as well as in customers’ mind space.
                            </p>
                            {/* <p className="text-gray-vessella pertili-font">
                                To craft luxury living spaces in the most life-friendly locales, creating a world-class ambience in gated communities and maintaining long-term relationships with customers.
                            </p> */}
                        </motion.div>
                    </motion.div>

                    {/* Mission Section */}
                    <motion.div
                        className="row py-5 mt-4"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <motion.div
                            className="col-md-6 py-5 order-2 order-md-1"
                            variants={slideLeft}
                        >
                            <h2 className="mb-3 display-5">Mission</h2>
                            <p className="text-gray-vessella pertili-font fs-3">
                                To craft luxury living spaces in the most life-friendly locales, creating a world-class ambience in gated communities and maintaining long-term relationships with customers.
                            </p>
                            {/* <p className="text-gray-vessella pertili-font">
                                We are dedicated to delivering thoughtfully designed homes that elevate lifestyles while respecting the environment and surrounding communities. Through meticulous planning, superior materials, and skilled craftsmanship, we ensure every project reflects quality and care. Our mission extends beyond construction—to continuously support our customers and nurture relationships built on trust, integrity, and shared growth.
                            </p> */}
                        </motion.div>
                        <motion.div
                            className="col-md-6 p-lg-3 order-1 order-md-2"
                            variants={slideRight}
                        >
                            <img
                                src={image2}
                                alt="Mission"
                                className="img-fluid"
                                style={{ borderRadius: "10px", borderEndEndRadius: "50px" }}
                            />
                        </motion.div>
                    </motion.div>
                </div>
            </motion.section>


            {/* <motion.section
                className="leadership-section py-5"
                variants={containerVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.2 }}
                style={{ overflowX: "hidden" }}
            >
                <div className="container">
                    <motion.div className="d-flex align-items-center mb-3" variants={fadeUp}>
                        <span className="about-dot"></span>
                        <span className="section-label">PIONEERS IN LEADERSHIP AND GROWTH</span>
                    </motion.div>

                    <motion.h2
                        className="section-title mb-4"
                        variants={wordContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        {leadershipHeading.map((word, i) => (
                            <motion.span
                                key={`leader-${i}`}
                                variants={wordVariant}
                                style={{
                                    display: "inline-block",
                                    marginRight: "0.35em",
                                }}
                            >
                                {word}
                            </motion.span>
                        ))}
                    </motion.h2>


                   
                    <div className="slider-wrapper">
                        <div
                            className="slider-track"
                            style={{ transform: `translateX(-${index * 25}%)` }}
                        >
                            {executiveData.map((item, i) => (
                                <div className="slider-item" key={i}>
                                    <div
                                        className="leader-card"
                                        onClick={() => setSelectedLeader(item)}
                                    >
                                        <div className="icon">+</div>
                                        <div className="leader-info">
                                            <h4 className="display-6">{item.name}</h4>
                                            <p>{item.role}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                   
                    <motion.div
                        className="embla-controls"
                        variants={fadeUp}
                    >
                        <div className="embla-progress">
                            <div
                                className="embla-progress-bar"
                                style={{
                                    transform: `translate3d(${progress}%, 0, 0)`,
                                }}
                            />
                        </div>

                        <div className="embla-buttons">
                            <button
                                className="nav-btns"
                                onClick={prevSlide}
                                disabled={index === 0}
                            >
                                ←
                            </button>

                            <button
                                className="nav-btns"
                                onClick={nextSlide}
                                disabled={index >= leaders.length - visibleSlides}
                            >
                                →
                            </button>
                        </div>
                    </motion.div>
                </div>
            </motion.section>

            {selectedLeader && (
                <div className="leader-modal-overlay">
                    <div className="leader-modal">
                        <button
                            className="close-btn"
                            onClick={() => setSelectedLeader(null)}
                        >
                            ✕
                        </button>

                        <h2 className="display-5">{selectedLeader.name}</h2>
                        <h4 className="display-6">{selectedLeader.role}</h4>

                        {selectedLeader.bio.map((para, i) => (
                            <p key={i}>{para}</p>
                        ))}
                    </div>
                </div>
            )} */}
        </>
    );
}